export default __webpack_public_path__ + "static/media/5.4fb900bb.webp";